import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: 'input[type=password]',
})
export class ShowPasswordDirective {

    private passwordVisible = false;
    private passwordElement;
    private toggleElement;

    constructor(
        private elRef: ElementRef,
        private renderer: Renderer2
    ) {

    }

    ngOnInit() {
        const wrapper = document.createElement('div');
        wrapper.classList.add('password-wrapper');
        const password = this.elRef.nativeElement;
        this.passwordElement = password;
        const error = this.elRef.nativeElement.nextSibling;
        this.renderer.appendChild(password.parentNode, wrapper);
        this.renderer.removeChild(password.parentNode, this.elRef.nativeElement, true);
        this.renderer.insertBefore(password.parentNode, wrapper, error);
        this.renderer.appendChild(wrapper, password);
        const show = this.renderer.createElement('div');
        this.toggleElement = show;
        this.renderer.addClass(show, 'bx');
        this.renderer.addClass(show, 'bx-show-alt');
        this.renderer.addClass(show, 'toggle-password-show');
        this.renderer.appendChild(wrapper, show);
        this.renderer.listen(show, 'click', this.togglePasswordShow)
    }

    private togglePasswordShow = () => {
        if (this.passwordVisible) {
            this.renderer.removeAttribute(this.passwordElement, 'type');
            this.renderer.setAttribute(this.passwordElement, 'type', 'password');
            this.renderer.removeClass(this.toggleElement, 'bx-hide');
            this.renderer.addClass(this.toggleElement, 'bx-show-alt');
        } else {
            this.renderer.removeAttribute(this.passwordElement, 'type');
            this.renderer.setAttribute(this.passwordElement, 'type', 'text');
            this.renderer.removeClass(this.toggleElement, 'bx-show-alt');
            this.renderer.addClass(this.toggleElement, 'bx-hide');
        }
        this.passwordVisible = !this.passwordVisible;
    }

}
